import { useSelector } from "react-redux";

import SponsorBy from "../SponsorBy/component";
import LinkLabel from "../LinkLabel/component";

import { isAdvertiserSponsored } from "../../../../utils/sponsor/library";

const MetaLabel = ({ insideBreadcrumbs } = {}) => {
    const sponsorBio = useSelector((state) => state.detail.content.sponsorBio);
    const departments = useSelector(
        (state) => state.detail.content.departments
    );
    const flag = useSelector((state) => state.detail.content.flag);

    // CBC content sponsored by an Advertiser (PRFD-4441)
    return isAdvertiserSponsored(sponsorBio) ? (
        <SponsorBy />
    ) : (
        <LinkLabel
            departments={departments}
            label={flag}
            insideBreadcrumbs={insideBreadcrumbs}
        />
    );
};

export default MetaLabel;
